{
  "name": "inedit_connect",
  "version": "26.10.5-beta.9",
  "shortcut_name": "ic",
  "scripts": {
    "dev": "vite --mode dev",
    "typecheck": "vue-tsc --noEmit",
    "build": "VITE_SENTRY_ENVIRONMENT=production VITE_BACKEND_URL='https://w2pcommunity.tpv7q9c17jna6.eu-west-3.cs.amazonlightsail.com/api' vite build",
    "build:test": "VITE_SENTRY_ENVIRONMENT=test VITE_BACKEND_URL='https://nreservice.inedit.com/api' vite build",
    "build:beta": "VITE_SENTRY_ENVIRONMENT=beta VITE_BACKEND_URL='https://connectbeta.inedit.com/api' vite build",
    "build:localdev": "VITE_SENTRY_ENVIRONMENT=localdev VITE_BACKEND_URL='http://localhost:3000' vite build",
    "test": "vitest src/tests/unit",
    "test:unit": "vitest run src/tests/unit",
    "cypress:open": "cypress open",
    "test:e2e": "NO_COLOR=1 cypress run --browser chrome --spec 'src/tests/cypress/e2e/*.cy.ts'",
    "pw:test": "playwright test --project=phase1 --project=phase2 --project=phase3",
    "pw:test:headed": "playwright test --headed --project=phase1 --project=phase2 --project=phase3",
    "pw:test:ui": "playwright test --ui",
    "pw:install": "playwright install chromium",
    "ci:test": "start-server-and-test  dev http://localhost:8080 test:e2e",
    "ci:test:pw": "start-server-and-test  dev http://localhost:8080 pw:test",
    "preview": "vite preview",
    "lint": "eslint src/**/*.{ts,vue,d.ts}",
    "format": "prettier --write src/**/**/*.{ts,vue,d.ts}",
    "ci:backend": "start-server-and-test backend:test http://localhost:3000 ci:test",
    "backend:test": "cd ../poi-backend && npm run dev:e2e",
    "licenses-report": "license-checker-rseidelsohn --customPath format.json --csv > licenses.csv"
  },
  "dependencies": {
    "@iconify/vue": "^4.1.2",
    "@primeuix/themes": "^1.2.3",
    "@primevue/core": "^4.2.4",
    "@primevue/forms": "^4.5.4",
    "@sentry/vite-plugin": "^5.4.0",
    "@sentry/vue": "^10.69.0",
    "@shopify/draggable": "^1.2.1",
    "@tailwindcss/vite": "^4.2.2",
    "@tanstack/vue-query": "^5.90.7",
    "@tanstack/vue-query-devtools": "^6.1.2",
    "@types/cypress-cucumber-preprocessor": "^4.0.5",
    "@types/html2pdf.js": "^0.10.0",
    "@vuelidate/core": "^2.0.3",
    "@vuelidate/validators": "^2.0.4",
    "@vueuse/core": "10.9.0",
    "@vueuse/integrations": "10.0.2",
    "axios": "^1.7.2",
    "chart.js": "^4.4.3",
    "chartjs-adapter-dayjs-4": "^1.0.4",
    "convert": "^4.14.1",
    "dayjs": "^1.11.11",
    "eslint-plugin-oxlint": "^0.16.2",
    "eslint-plugin-prettier": "^5.5.4",
    "fractional-indexing": "^2.1.0",
    "happy-dom": "^7.8.1",
    "html2canvas": "^1.4.1",
    "html2pdf.js": "^0.13.0",
    "json-diff-ts": "^4.8.2",
    "jsonwebtoken": "^9.0.2",
    "jspdf": "^2.5.1",
    "jwt-decode": "^4",
    "lodash": "^4.17.21",
    "moment": "^2.30.1",
    "oxlint": "^0.16.2",
    "pdf-lib": "^1.17.1",
    "pdfjs-dist": "^5.4.530",
    "pinia": "^2.1.7",
    "primeicons": "^7.0.0",
    "primevue": "^4.5.4",
    "qrcode": "^1.5.4",
    "socket.io-client": "^4.8.1",
    "tailwindcss-primeui": "^0.6.1",
    "typescript": "^4.9.5",
    "uuid": "^9.0.1",
    "vite": "^8.0.0",
    "vue": "^3.5.13",
    "vue-cookies": "^1.8.4",
    "vue-country-flag-next": "^2.3.2",
    "vue-i18n": "^9.13.1",
    "vue-router": "^4.3.2",
    "vue-shopify-draggable": "^0.0.3",
    "vue-tsc": "^1.8.27",
    "vue3-html2pdf": "^1.1.2",
    "vue3-simple-html2pdf": "^0.0.7",
    "vuedraggable": "^4.1.0",
    "vuex": "^4.1.0"
  },
  "devDependencies": {
    "@badeball/cypress-cucumber-preprocessor": "^20.0.5",
    "@bahmutov/cypress-esbuild-preprocessor": "^2.2.0",
    "@eslint/js": "^9.20.0",
    "@luco-inc/pnpm-license-exporter": "^3.2.0",
    "@pinia/testing": "^0.1.7",
    "@playwright/test": "^1.58.2",
    "@primevue/auto-import-resolver": "^4.0.5",
    "@types/lodash": "^4.17.4",
    "@types/node": "^20.0.0",
    "@types/qrcode": "^1.5.6",
    "@types/uuid": "^8.3.4",
    "@typescript-eslint/parser": "^8.24.1",
    "@vitejs/plugin-vue": "^6.0.5",
    "@vue/eslint-config-prettier": "^10.2.0",
    "@vue/eslint-config-typescript": "^14.4.0",
    "@vue/test-utils": "^2.4.6",
    "chai": "^4.4.1",
    "cypress": "^10.11.0",
    "eslint": "^9.20.1",
    "eslint-import-resolver-typescript": "^3.6.1",
    "eslint-plugin-cypress": "^2.15.2",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-vue": "^9.32.0",
    "globals": "^15.15.0",
    "prettier": "^3.3.3",
    "prettier-eslint": "^16.3.0",
    "prettier-plugin-tailwindcss": "^0.6.6",
    "sass": "^1.77.2",
    "sass-loader": "^13.3.3",
    "start-server-and-test": "^1.15.5",
    "tailwindcss": "^4.2.2",
    "typescript-eslint": "^8.24.1",
    "unplugin-vue-components": "^0.27.4",
    "vite-plugin-vue-devtools": "^8.1.0",
    "vitest": "^4.1.0",
    "vue-eslint-parser": "^9.4.3"
  },
  "packageManager": "pnpm@10.2.0+sha512.0d27364e0139c6aadeed65ada153135e0ca96c8da42123bd50047f961339dc7a758fc2e944b428f52be570d1bd3372455c1c65fa2e7aa0bfbf931190f9552001"
}
